export default __webpack_public_path__ + "static/media/arrange_meeting.f6814522.svg";